import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0b1aa428"
import script from "./partyDetail.js?vue&type=script&lang=js&external"
export * from "./partyDetail.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports